import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { cn, Typography, WalletIcon, WalletIconVariant } from "@kyan/ui";

import { useEoa } from "#/store/wallet/eoa/eoa";
import { getChainName } from "#/utils/chain";
import { formatAddress } from "#/utils/formatAddress";

export const NetworkAndWallet: React.FC = () => {
  const { eoa } = useEoa();
  const { primaryWallet, network } = useDynamicContext();

  const items = [
    {
      label: "Network",
      value: network ? getChainName(network) : "-",
      icon: undefined,
    },
    {
      label: "Connected wallet",
      value: formatAddress(eoa),
      icon: primaryWallet ? (
        <WalletIcon
          size="sm"
          variant={
            primaryWallet.connector.name.toLowerCase() as WalletIconVariant
          }
          className={cn(
            "ml-1 grayscale transition duration-500",
            "group-hover:grayscale-0 group-aria-expanded:grayscale-0",
          )}
        />
      ) : undefined,
    },
  ];

  return (
    <div className="flex items-center justify-between">
      {items.map((item) => (
        <div key={item.label} className="flex items-center gap-2">
          {item.icon}

          <div className="grid place-items-start gap-0.5">
            <Typography size={11}>{item.label}</Typography>
            <Typography primary size={12}>
              {item.value}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
};
